import type { Chapter } from '@/types/nf'

export function sortChaptersByNumber(chapters: readonly Chapter[]): Chapter[] {
  return [...chapters].sort((a, b) => a.chapter_number - b.chapter_number)
}

export function getChapterDisplayTitle(chapter: Chapter, untitledLabel: string): string {
  const title = chapter.title.trim()
  return title || `${untitledLabel} ${chapter.chapter_number}`
}

export function getSelectableChapterId(
  chapters: readonly Chapter[],
  selectedChapterId: string | null,
  projectId: string,
  branchId: string,
): string | null {
  if (!selectedChapterId) return null
  const selected = chapters.find((chapter) => chapter.id === selectedChapterId)
  if (!selected) return null
  if (selected.project_id !== projectId || selected.branch_id !== branchId) return null
  return selected.id
}
